import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const usePCRSCredentials = () => {
  const tenantVal = useSelector((state) => state.auth.user?.tenant) || localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["pcrsCredentials", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();

      try {
        const response = await axiosInstance.get(
          `${tenantVal}/pcrs/credentials`
        );

        const data = response.data;
        return Array.isArray(data) ? data : data ? [data] : [];
      } catch (error) {
        // A tenant may simply have no PCRS credentials configured yet. That is
        // a valid state, not an error — return an empty list so consumers show
        // an empty table instead of surfacing a global error toast.
        if (error?.response?.status === 404) {
          return [];
        }

        throw error;
      }
    },
    enabled: !!tenantVal,
    // "Not configured yet" is already absorbed as a 404 above, so anything that
    // reaches here is a genuine failure and must not be suppressed.
    meta: { errorMessage: "Error fetching PCRS credentials" },
  });
};

export { usePCRSCredentials };